import React from 'react';
import { Link } from 'gatsby';
import { MenuItem } from "@mui/material";
import {Translate} from "@mui/icons-material";
import {LocalizedString} from "../Strings";

const LanguageSelectionLink = ({ onClick, className, locale }) =>
    <MenuItem {...{ onClick, className }} key={`languageSelectionLink`} component={Link} to={`/languages`}>
        <Translate sx={{ verticalAlign: 'inherit' }}/> <LocalizedString string={'Language selection'} locale={locale} />
    </MenuItem>

export default LanguageSelectionLink
